import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(updateUserData: $input) {
      id
      uid
      firstName
      lastName
      email
      phone
      userImg
      role
      gender
      createdAt
      updatedAt
      userPreferences {
        ladyDrivers
        ecoFriendlyRides
        luxuryCars
        standardCars
        moreThanTwoSeats
      }
      userVehicles {
        id
        make {
          id
          name
        }
        model
        spec {
          engineSize
          fuelConsumption
        }
        fuelTypes {
          id
          type
          price
        }
      }
    }
  }
`;
